// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"a4866ea5","232":"09144ddd","348":"125844d6","391":"64ea3eb1","490":"5da3a8ec","516":"b5d33f15","667":"35dd8522","826":"edba5a6e"}[chunkId] + ".chunk.js";
};